/**
 * Shared cache: image URL -> { w, h }.
 * Used by PhotoViewer preload (to store dimensions when preloading) and MapWrapper (to avoid waiting for onload when switching photos).
 */
const cache = new Map();

export function getImageDimensions(url) {
  return cache.get(url) ?? null;
}

export function setImageDimensions(url, w, h) {
  if (url != null && typeof w === 'number' && typeof h === 'number') {
    cache.set(url, { w, h });
  }
}
